export function addRemoveFromArray(item, itemsArray, shouldAdd) {
  const alreadyInArray = itemsArray.includes(item)
  if (shouldAdd) {
    if (!alreadyInArray) { itemsArray = itemsArray.concat(item) }
  } else {
    if (alreadyInArray) { itemsArray = itemsArray.filter(function (itemInArray) { return itemInArray !== item }) }
  }
  return itemsArray
}

export function addRemoveObject(keyToUpdate, valueObjectToUpdate, objectToUpdate) {
  let updatedObject = objectToUpdate
  const objectIsEmpty = Object.keys(updatedObject).length < 1,
    valueIsEmpty = Object.keys(valueObjectToUpdate).length < 1

  if (objectIsEmpty && valueIsEmpty) {
  } else if (objectIsEmpty && !valueIsEmpty) {
    let updatedObject = {}
    updatedObject[keyToUpdate] = valueObjectToUpdate
    return updatedObject
  } else {
    for (let key in updatedObject) {
      if (key === keyToUpdate) {
        if (valueIsEmpty) {
          delete updatedObject[key]
        } else {
          updatedObject[key] = valueObjectToUpdate
        }
      }
    }
  }
  return updatedObject
}

export function groupBy(arrayToGroup, keyToGroupBy) {
  // from https://stackoverflow.com/questions/14446511
  return arrayToGroup.reduce(function(rv, x) {
    (rv[x[keyToGroupBy]] = rv[x[keyToGroupBy]] || []).push(x);
    return rv;
  }, {})
}

export function isObject(obj) {
  return typeof obj === 'function' || (typeof obj === 'object' && !!obj)
}

export function shortenNumber(number, useCurrency) {
  // from: https://stackoverflow.com/a/55987576
  let n = parseInt(number),
    isDecimal = number > 0 && number < 1,
    isNeg = n < 0,
    absNumber = Math.abs(n),
    shortNumber

  switch (true) {
    case (absNumber >= 1e3 && absNumber < 1e6):
      shortNumber = `${+(absNumber / 1e3).toFixed(1)}k`
      break
    case (absNumber >= 1e6 && absNumber < 1e9):
      shortNumber = `${+(absNumber / 1e6).toFixed(1)}m`
      break
    case (absNumber >= 1e9 && absNumber < 1e12):
      shortNumber = `${+(absNumber / 1e9).toFixed(1)}b`
      break
    case (absNumber >= 1e12):
      shortNumber = `${+(absNumber / 1e12).toFixed(1)}t`
      break
    default:
      shortNumber = isDecimal ? number.toFixed(2) : absNumber
  }

  let currencyNumber = isNeg ? `-$${shortNumber}` : `$${shortNumber}`
  shortNumber = isNeg ? `-${shortNumber}` : shortNumber
  return useCurrency ? currencyNumber : shortNumber
}

/**
 * Calculates the difference from a point on site to the top of an element
 * @param y {number} = A vertical point on the page
 * @param element {object|string} = DOM element or selector
 */
export function spaceBetween(y, element) {
  if(typeof element === 'string') {
    element = document.querySelector(element)
  }

  if(!element) {
    throw new Error(`Unable to find element for selector: ${selector}`)
  }

  const elementTop = element.getBoundingClientRect().top
  return elementTop - y
}
export function isNil(value) {
  return value === null || value === undefined
}

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3]
  }
  return null
}

export function isGifImage(imageFile) {
  const imageType = imageFile ? (imageFile.type || imageFile.file_name.toLowerCase()) : ''
  return imageType.includes('gif') 
}

export function pluralize(value, singular, plural) {
  const type = value == 1 ? singular : plural
  return `${value} ${type}`
}

/**
 * Returns the index of the blot when given a domNode
 * @param {string} text - text to be spliced
 * @param {number} index - index to insert text
 * @param {number} replacementString - text to be inserted
 */

export function spliceIntoString(text, index, replacementString){
  return index || index === 0 ? `${text.slice(0,index)} ${replacementString} ${text.slice(index)}` : text;
}